import React from 'react';
import {dateTime} from './DateFormats';


import component, {classnames} from './component';
import Link from './Link';


const TeamBlock = component('TeamBlock', function({team, teamType, type}) {

  const TeamPicture = component('TeamPicture', function({image}) {

    const avatar =  image
      ? image + '?crop=1&w=288&h=240'
      : require('../img/teamEmptyAvatarSquare.png');

    return (
      <i className="GamesItem-TeamAvatar" style={{
        backgroundImage: `url(${avatar})`
      }} />
    )
  });

  const image = type === 'Full' ? <TeamPicture image={team.get('image')} /> : null;

  return (
    <div className={"GamesItem-Team" + teamType}>
      {image}
      <span className="GamesItem-TeamName">{team.get('title')}</span>
    </div>
  )
});

export default component('GamesItem', function({data, type}) {

  if (!data.get('results')) {
    return null;
  }

  const itemClasses = {'GamesItem': true};

  itemClasses['GamesItem--' + type] = true;

  const date = dateTime(data.get('finished_at'));
  const teamA = data.cursor('team_a');
  const teamB = data.cursor('team_b');
  const results = summGameResults(data.get('results').toJS());

  return (
    <Link name='gameDetails' params={{id: data.get('id')}}>
      <div className={classnames(itemClasses)}>
        <div className="GamesItem-Date">{date}</div>
        <TeamBlock team={teamA} teamType="A" type={type} />
        <div className="GamesItem-Score">
          <span className="GamesItem-ScoreValue">
            {results[0]}:{results[1]}
          </span>
        </div>
        <TeamBlock team={teamB} teamType="B" type={type} />
        <div className="GamesItem-Сaption">
          {data.get('tournament_title')}
        </div>
      </div>
    </Link>
  )

})

export const summGameResults = (gameResults) => {
  let results = [0, 0];
  gameResults.forEach((result) => {
    result.team_a_score > result.team_b_score
        ? results[0]++
        : result.team_a_score < result.team_b_score && results[1]++;
  });
  return results;
};



// WEBPACK FOOTER //
// ./src/components/GamesItem.js